import { ID } from 'api'
import { VirtualCurrencySale } from 'api/virtual-currency-sale/types'
import { graphql } from 'msw'
import db from '../db'

const vcsHandlers = [
  graphql.query('listVirtualCurrencySales', (req, res, ctx) => {
    const applicationId = req.variables.id as ID
    const virtualCurrencySales = db.vcs.getAll(
      (vcs) => vcs.application.id === applicationId
    )
    return res(ctx.data({ virtualCurrencySales }))
  }),

  graphql.mutation('createVirtualCurrencySale', (req, res, ctx) => {
    const application = db.application.get(req.variables.applicationId as ID)
    const placements = req.variables.placementsIds
      ? db.placement
          .getAll()
          .filter((placement) =>
            req.variables.placementsIds.includes(placement.id)
          )
      : []

    const virtualCurrencySale = db.vcs.create({
      ...(req.variables as VirtualCurrencySale),
      application,
      placements,
    })

    return res(ctx.data({ virtualCurrencySaleCreate: { virtualCurrencySale } }))
  }),

  graphql.mutation('updateVirtualCurrencySale', (req, res, ctx) => {
    const placements = req.variables.placementsIds
      ? db.placement
          .getAll()
          .filter((placement) =>
            req.variables.placementsIds.includes(placement.id)
          )
      : []
    const virtualCurrencySale = db.vcs.update({
      ...(req.variables as VirtualCurrencySale),
      placements,
    })
    return res(ctx.data({ virtualCurrencySaleUpdate: { virtualCurrencySale } }))
  }),

  graphql.mutation('deleteVirtualCurrencySale', (req, res, ctx) => {
    const id = req.variables.id
    const virtualCurrencySale = db.vcs.remove(id)
    return res(ctx.data({ virtualCurrencySale }))
  }),
]

export default vcsHandlers
